module.exports = __webpack_public_path__ + "img/intro2.80fc37be.png";